import React from "react";
import Img from "./Img";
import { getLabel } from "../InitData";

export default function BettingClosedMessageInline() {
    return (
        <div className="c_40" data-inline="true">
            <Img className="c_40_1" src="icon_locked.svg" height="16px" width="16px" />
            <div className="c_40_2">{getLabel('general.giocabilita_chiusa')}</div>
        </div>
    )
}
